import type { ReactElement, ReactNode } from 'react';

import BpkLoadingButtonComponent from '@skyscanner/backpack-web/bpk-component-loading-button';

import { withI18n } from '../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';

type Props = {
  i18n: I18nService;
  children?: ReactElement | string;
  className?: string;
  large?: boolean;
  disabled?: boolean;
  iconOnly?: boolean;
  icon?: ReactElement;
  link?: boolean;
  loading?: boolean;
  onClick?: Maybe<Function>;
  href?: string;
  featured?: boolean;
  iconDisabled?: ReactNode;
  submit?: boolean;
};

/* BpkLoadingButton
 * Backpack loading button will cause the client crash when user using google translation.
 *
 * This wrapper will avoid the client crash.
 */

const BpkLoadingButton = ({ children, i18n, ...rest }: Props) => {
  if (!children) {
    return (
      <BpkLoadingButtonComponent {...rest}>
        <span className="visually-hidden">
          {i18n.translate('hdb_search_filters_button_loading')}
        </span>
      </BpkLoadingButtonComponent>
    );
  }

  return (
    <BpkLoadingButtonComponent {...rest}>
      <span>{children}</span>
    </BpkLoadingButtonComponent>
  );
};

export default withI18n(BpkLoadingButton);
